<div class="betbuilder-help-page" msOutsideInteractionExclude=".modal-dialog-header-wrapper,.header-title" (msOutsideInteraction)="close()">
    @if (showHeader) {
        <div class="help-page-heading" (click)="toggleHelp()">
            <div class="help-page-title">{{ translations['helpPageTitle'] }}</div>
            @if (isPrecreatedBetBuilderEnabled && collapsible) {
                <span class="help-page-toggle-icon" [ngClass]="collapsed ? 'theme-info' : 'theme-info-i'"></span>
            }
        </div>
    }
    <div class="help-page-build-a-bet-info" [innerHTML]="helpPageContent"></div>
    @if (!collapsed) {
        <div class="help-page-toggle-wrap">
            <div class="example-title">{{ translations['exampleTitle'] }}</div>
            <div class="example">
                <div class="legs">
                    @for (leg of helpPageLegs; track leg) {
                        <div class="market-leg">
                            <div class="circle-overlay"><div class="theme-radio-off"></div></div>
                            <span class="leg">{{ leg }}</span>
                        </div>
                    }
                </div>
                <div class="event-name">{{ exampleEventName }}</div>
                <span class="odds">{{ exampleOdds }}</span>
            </div>
            <div class="help-page-footer">
                @if (showHelpButtons) {
                    <div class="help-page-buttons">
                        <button class="btn btn-primary" (click)="onOkClicked()">{{ okButtonText }}</button>
                        <button class="btn btn-tertiary" [innerHTML]="helpPageLearnMoreLink" (click)="onLearnMoreClick()"></button>
                    </div>
                }
                <div class="help-page-link" [innerHTML]="helpPageLink"></div>
            </div>
        </div>
    }
</div>
